import React from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Navigate, useLocation } from 'react-router-dom';
import { LoginPage } from './AuthComponents';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const location = useLocation();

  if (inProgress !== 'none') {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    // If user is not authenticated and not already on root route, redirect to root
    if (location.pathname !== '/') {
      // Store the intended route for redirect after login
      sessionStorage.setItem('intendedRoute', location.pathname + location.search);
      return <Navigate to="/" replace />;
    }
    return <LoginPage />;
  }

  return <>{children}</>;
};
